module.exports = __webpack_public_path__ + "static/img/logo_1.532b96b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo_1.png
// module id = iWV5
// module chunks = 34